export default "__VITE_ASSET__bc2425e8__"